import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ResearchLibraryItem } from '@/hooks/research-generator';
import ResearchCardItem from './ResearchCardItem';

interface ResearchCardGridProps {
  research: ResearchLibraryItem[];
  isLoading: boolean;
  onResearchClick: (researchId: string) => void;
  onToggleFavorite: (researchId: string) => Promise<void>;
  showFavoriteButton?: boolean; // Optional prop to hide favorite buttons
  contentType?: 'research' | 'private_research'; // NEW: Optional prop for content type
  hideStorageButton?: boolean; // NEW: Optional prop to hide storage buttons
}

export const ResearchCardGrid: React.FC<ResearchCardGridProps> = ({
  research,
  isLoading,
  onResearchClick,
  onToggleFavorite,
  showFavoriteButton = true, // Default to true for backward compatibility
  contentType = 'research', // Default to 'research' for backward compatibility
  hideStorageButton = false, // Default to false for backward compatibility
}) => {
  if (isLoading || research.length === 0) {
    return null;
  }

  return (
    <motion.div 
      className="grid grid-cols-1 2xl:grid-cols-2 gap-2 md:gap-6"
      layout
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
      style={{ 
        transform: 'translateZ(0)',
        backfaceVisibility: 'hidden',
        willChange: 'transform'
      }}
    >
      <AnimatePresence mode="popLayout">
        {research.map((researchItem, index) => (
          <ResearchCardItem
            key={researchItem.id}
            research={researchItem}
            index={index}
            onResearchClick={onResearchClick}
            onToggleFavorite={onToggleFavorite}
            showFavoriteButton={showFavoriteButton}
            contentType={contentType}
            hideStorageButton={hideStorageButton}
          />
        ))}
      </AnimatePresence>
    </motion.div>
  );
};

export default ResearchCardGrid;
